import React from 'react';
import styled from 'styled-components';
import { Body5 } from '@ui';
import { DocumentIcon } from '@assets/icons/svgs/DocumentIcon';
import { CloseButton } from '@ui/buttons/CloseButton';

const SelectedDocumentWrapper = styled.div`
  display: inline-block;
`;

const ContentWrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  max-width: 600px;
`;

const IconWrapper = styled.div`
  margin-right: 8px;
  flex-shrink: 0;

  svg {
    padding-top: 1px;
    height: 16px;
    width: 16px;

    path {
      fill: ${({ theme }) => theme.themeColors.text};
    }
  }
`;

const FileNameWrapper = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex-shrink: 1;
`;

const CloseButtonWrapper = styled.div`
  margin-left: 8px;
  flex-shrink: 0;

  svg {
    padding-top: 1px;
    height: 12px;
    width: 12px;

    path {
      fill: ${({ theme }) => theme.themeColors.text};
    }
  }
`;

export function SelectedDocument({ doc, handleRemove }) {
  if (!doc) return null;

  const { filename } = doc;
  return (
    <SelectedDocumentWrapper>
      <ContentWrapper>
        <IconWrapper>
          <DocumentIcon />
        </IconWrapper>
        <FileNameWrapper>
          <Body5>{filename}</Body5>
        </FileNameWrapper>
        <CloseButtonWrapper>
          <CloseButton onClick={() => handleRemove(doc)} />
        </CloseButtonWrapper>
      </ContentWrapper>
    </SelectedDocumentWrapper>
  );
}
